"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _TableModule = _interopRequireDefault(require("../Table.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DataTableMobile = function DataTableMobile(_ref) {
  var _columns$, _columns$2;
  var value0 = _ref.value0,
    copy = _ref.copy,
    columns = _ref.columns,
    isTopRow = _ref.isTopRow,
    rowHasAccentColours = _ref.rowHasAccentColours;
  var hasValuesInColumns1And2 = ((_columns$ = columns[1]) === null || _columns$ === void 0 ? void 0 : _columns$.value) && ((_columns$2 = columns[2]) === null || _columns$2 === void 0 ? void 0 : _columns$2.value);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _TableModule["default"].tableMobile,
    role: "table",
    "aria-label": "Mobile comparison table",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _TableModule["default"].tableMobileRow,
      role: "row",
      "aria-labelledby": "row-title",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnames["default"])(_TableModule["default"].tableMobileCell, _TableModule["default"].rowTitle, _defineProperty(_defineProperty({}, _TableModule["default"].topMobileTable, isTopRow), _TableModule["default"].topMobileRow, !isTopRow)),
        role: "cell",
        id: "row-title",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
          children: value0
        }), copy && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: copy
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classnames["default"])(_TableModule["default"].tableMobileRow, _defineProperty({}, _TableModule["default"].topMobileContent, isTopRow)),
      role: "row",
      children: hasValuesInColumns1And2 ? columns.map(function (column, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _classnames["default"])(_TableModule["default"].tableMobileCell, rowHasAccentColours ? _TableModule["default"]["border".concat(column.color)] : 'Default'),
          role: "cell",
          children: column.value && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: column.value
          })
        }, index);
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_TableModule["default"].tableMobileCell, _TableModule["default"].singleCell),
        role: "cell",
        style: {
          flex: 3
        },
        children: columns[0].value && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: columns[0].value
        })
      })
    })]
  });
};
var _default = exports["default"] = DataTableMobile;